<div class="purchase-vehicle" [ngClass]="{ 'pre-enquiry': mode === 'vehicle' }">
	<!-- STEP HEADER BAR   -->

	<cng-step-header
		*ngIf="mode === 'enquiry'"
		[current_step_key]="current_step_key"
		[location]="'engage_configure'"
		(jump)="jumpTo($event)"
	></cng-step-header>

	<!--  END STEP HEADER BAR  -->

	<!--  HEADING - FULL - NOT STARTED  -->

	<div *ngIf="mode === 'vehicle' && step_mode === 'full'" class="heading">
		<ui-concierge
			data-element-view="concierge__engage_configure_purchase_vehicle_step__[Time to customise your deal!]"
		>
			<h1>Time to customise your deal!</h1>
			<p class="hidden-xxs hidden-xs">
				Review your new vehicle below and click "Get Started" when you're ready to start.
			</p>
		</ui-concierge>
	</div>

	<!--  END HEADING - FULL - NOT STARTED  -->

	<!--  HEADING - RESERVE - NOT STARTED  -->

	<div *ngIf="mode === 'vehicle' && step_mode === 'reserve'" class="heading">
		<ui-concierge
			data-element-view="concierge__engage_configure_purchase_vehicle_step__[Reserve this vehicle in minutes!]"
		>
			<h1>Reserve this vehicle in minutes!</h1>
			<p class="hidden-xxs hidden-xs">Confirm vehicle and tap 'Reserve this Vehicle' to begin...</p>
		</ui-concierge>
	</div>

	<!--  END HEADING - RESERVE - NOT STARTED  -->

	<!--  HEADING - PART EXCHANGE - NOT STARTED  -->

	<div *ngIf="mode === 'vehicle' && step_mode === 'part_exchange'" class="heading">
		<ui-concierge
			data-element-view="concierge__engage_configure_purchase_vehicle_step__[Get your valuation in minutes!]"
		>
			<h1>Get your valuation in minutes!</h1>
			<p class="hidden-xxs hidden-xs">Confirm vehicle and tap 'Get my Valuation' to begin...</p>
		</ui-concierge>
	</div>

	<!--  END HEADING - PART EXCHANGE - NOT STARTED  -->

	<!--  HEADING - FULL - ENQUIRY  -->

	<div *ngIf="mode === 'enquiry' && step_mode === 'full'" class="heading">
		<ui-concierge
			data-element-view="concierge__engage_configure_purchase_vehicle_step__[CUSTOMER_FIRST_NAME, time to customise your deal.]"
		>
			<h1>{{ customer.first_name }}, time to customise your deal.</h1>
			<p class="hidden-xxs hidden-xs">
				Review your new vehicle below and click 'Next' when you're ready to start.
			</p>
		</ui-concierge>
	</div>

	<!--  HEADING - FULL - ENQUIRY  -->

	<!--  HEADING - RESERVE - ENQUIRY  -->

	<div
		*ngIf="mode === 'enquiry' && ((step_mode === 'part_exchange' && reserve_enabled) || step_mode === 'reserve')"
		class="heading"
	>
		<ui-concierge
			data-element-view="concierge__engage_configure_purchase_vehicle_step__[Reserve your vehicle, CUSTOMER_FIRST_NAME!]"
		>
			<h1>Reserve your vehicle, {{ customer.first_name }}!</h1>
			<p class="hidden-xxs hidden-xs">
				Review your new vehicle below and click 'Next' when you're ready to progress.
			</p>
		</ui-concierge>
	</div>

	<!--  HEADING - RESERVE - ENQUIRY  -->

	<!--  HEADING - PART EXCHANGE - ENQUIRY  -->

	<div *ngIf="mode === 'enquiry' && step_mode === 'part_exchange' && !reserve_enabled" class="heading">
		<ui-concierge
			data-element-view="concierge__engage_configure_purchase_vehicle_step__[Ready to get your part exchange valuation, CUSTOMER_FIRST_NAME?]"
		>
			<h1>Ready to get your part exchange valuation, {{ customer.first_name }}?</h1>
			<p class="hidden-xxs hidden-xs">
				Review your new vehicle below and click 'Next' when you're ready to progress.
			</p>
		</ui-concierge>
	</div>

	<!--  HEADING - PART EXCHANGE - ENQUIRY  -->

	<!--  GALLERY -->

	<cng-vehicle-images [vehicle]="vehicle"></cng-vehicle-images>

	<!--  END GALLERY  -->

	<!-- VEHICLE TITLE  -->

	<cng-vehicle-title [vehicle]="vehicle" [show_price]="true"></cng-vehicle-title>

	<!--  END VEHICLE TITLE  -->

	<!--  ICON CONTAINER  -->

	<div class="icon-list-container stripe bordered">
		<ui-icon-list [vehicle]="vehicle"></ui-icon-list>
	</div>

	<!--  END ICON CONTAINER  -->

	<!--  VEHICLE ADVERT TEXT  -->

	<p *ngIf="vehicle.information !== null" class="blurb" [innerHTML]="vehicle.information"></p>

	<!--  END VEHICLE ADVERT TEXT  -->

	<!--  STEP BAR  -->

	<cng-step-bar
		*ngIf="mode === 'enquiry'"
		[next_text]="'Next'"
		[current_step_key]="current_step_key"
		[show_back]="website_url !== null"
		[back_text]="'Showroom'"
		[back_url]="website_url"
		(jump)="jumpTo($event)"
	></cng-step-bar>

	<!-- END STEP BAR  -->

	<!--  START BUTTON  -->

	<div *ngIf="mode === 'vehicle'" class="start-button-container">
		<a
			class="button positive-button button-with-icon-right"
			[attr.data-element-click]="'button__engage_configure_step_bar__positive-button[' + get_started_text + ']'"
			(click)="onShowCustomerDetails()"
		>
			<i class="icon-arrow-right"></i>
			{{ get_started_text }}
		</a>
	</div>

	<!--  END START BUTTON  -->

	<!--  SCROLL FADES  -->

	<div class="scroll-fade top"></div>
	<div class="scroll-fade bottom"></div>

	<!--  END SCROLL FADES  -->
</div>
